GIFT_READY_STATE